/**
 * ## General functions
 *
 * @module controllers/func
*/

'use strict';

let kd;
let tables;


const init = (kdObj) => {
    kd = kdObj;
};


const getWaitTime = (preference) => {
    let seatCount = 0;
    const location = kd.doc('location')[0];
    const chart = kd.doc('chart', location.chart)[0];
    if (location.preferenceTypes[0].value === preference) {
        preference = null;
    }

    tables = chart.tables;
    const baseTurn = location.baseTurn;

    tables.forEach((table) => {
        if (!preference) {
            seatCount += table.seats;
        } else if (table.hasOwnProperty('preference1') && preference === table.preference1) {
            seatCount += table.seats;
        } else if (table.hasOwnProperty('preference2') && preference === table.preference2) {
            seatCount += table.seats;
        }
    });

    // subtract disabled seats

    const disabledTables = location.disabledTables;

    disabledTables.forEach((disabledTable) => {
        // get table size of each table
        for (let i = 0; i < chart.tables.length; ++i) {
            if (disabledTable === chart.tables[i].table) {
                if (!preference) {
                    seatCount -= chart.tables[i].seats;
                } else if (chart.tables[i].hasOwnProperty('preference1') &&
                chart.tables[i].preference1 == preference) {
                    seatCount -= chart.tables[i].seats;
                } else if (chart.tables[i].hasOwnProperty('preference2') &&
                chart.tables[i].preference2 == preference) {
                    seatCount -= chart.tables[i].seats;
                }
            }
        }
    });

    // get guests in queue

    let queuedCount = 0;

    const activitys = kd.where('activity', (obj) => {
        if (obj.status == 1 || obj.status == 2) {
            return true;
        }
    });

    activitys.forEach((activity) => {
        if (!preference) {
            queuedCount += parseInt(activity.size, 10);
        } else if (activity.preference.hasOwnProperty('preference1') &&
        activity.preference.preference1 == preference) {
            queuedCount += parseInt(activity.size, 10);
        } else if (activity.preference.hasOwnProperty('preference2') &&
        activity.preference.preference2 == preference) {
            queuedCount += parseInt(activity.size, 10);
        }
    });

    // get current turn time
    let waitTime = (queuedCount / seatCount) * baseTurn + (baseTurn / 8);
    if (preference) {
        // TODO: add option to make it exclusive prefences or not in dashboard.
        // Exclusive would mean distinct wait times based on prefernces, otherwise math is below
        waitTime += Math.ceil(getWaitTime() * 0.5);
    }
    let rounded = Math.ceil(waitTime / 5) * 5;
    if (isNaN(rounded)) {
        rounded = 10;
    }
    return rounded;
};

const getQueryVar = (variable) => {
    if (typeof window !== 'undefined') {
        const query = window.location.search.substring(1);
        const vars = query.split('&');
        for (let i = 0; i < vars.length; i++) {
            const pair = vars[i].split('=');
            if (decodeURIComponent(pair[0]) == variable) {
                return decodeURIComponent(pair[1]);
            }
        }
    }
    return null;
};

const isTableAvailable = () => {
    const disabledTables = kd.doc('location')[0].disabledTables;
    const chartID = kd.doc('location')[0].chart;
    const tablesdata = kd.doc('chart', chartID)[0].tables;
    const validTables = [];
    for (let t = 0; t < tablesdata.length; ++t) {
        if (tablesdata[t].type !== 'icon' && tablesdata[t].seats > 1) {
            validTables.push(tablesdata[t].table);
        }
    }
    const activity = kd.where('activity', (obj) => {
        if (obj.hasOwnProperty('status') && obj.hasOwnProperty('size') &&
            obj.status === 3 && obj.size > 1) {
            return true;
        }
    });
    let occupiedTables = Object.assign([], disabledTables);
    for (let a = 0; a < activity.length; ++a) {
        occupiedTables.push(activity[a].table);
        if (activity[a].hasOwnProperty('join') && activity[a].join.length) {
            occupiedTables = occupiedTables.concat(activity[a].join);
        }
    }
    if (occupiedTables.length >= validTables.length) {
        return false;
    }
    return true;
};

const getColorByBg = (bgColor) => {
    if (!bgColor) { return ''; }
    return (parseInt(bgColor.replace('#', ''), 16) > 0xffffff / 2) ? '#000' : '#fff';
};

const isMobile = () => {
    if (navigator.userAgent.match(/Android/i) ||
        navigator.userAgent.match(/webOS/i) ||
        navigator.userAgent.match(/iPhone/i) ||
        navigator.userAgent.match(/iPad/i) ||
        navigator.userAgent.match(/iPod/i) ||
        navigator.userAgent.match(/BlackBerry/i) ||
        navigator.userAgent.match(/Windows Phone/i)) {
        return true;
    }
    return false;
};


module.exports = {
    init,
    getWaitTime,
    getQueryVar,
    getColorByBg,
    isTableAvailable,
    isMobile,
};



/** WEBPACK FOOTER **
 ** ./src/controllers/func/index.js
 **/